export default {
	label: {
		display: 'flex',
		alignItems: 'center'
	}
};
